import { useState } from 'react';
import { Link } from 'react-router-dom';

import { routes } from '@/config/routes';
import { useDocumentMetadata } from '@/hooks/useDocumentMetadata';

import { AccountPageState, EmailChangeDialog } from '../components';
import { useCustomerProfile } from '../hooks';

export function SecurityPage() {
  useDocumentMetadata('Account Security');
  const query = useCustomerProfile();
  const [emailOpen, setEmailOpen] = useState(false);
  const profile = query.data?.profile;
  return (
    <AccountPageState
      loading={query.isLoading}
      error={query.isError}
      retry={() => void query.refetch()}
    >
      {profile && (
        <div className="account-page">
          <header>
            <p className="eyebrow">Protect your account</p>
            <h2>Security</h2>
            <p>Security changes may require verification so only you can make them.</p>
          </header>
          <div className="security-list">
            <section>
              <div>
                <strong>Sign-in email</strong>
                <p>
                  {profile.email} · {profile.emailVerified ? 'Verified' : 'Verification required'}
                </p>
              </div>
              <button type="button" onClick={() => setEmailOpen(true)}>
                Change email
              </button>
            </section>
            <section>
              <div>
                <strong>Password</strong>
                <p>Use the secure reset flow to choose a new password.</p>
              </div>
              <Link to={`${routes.forgotPassword}?email=${encodeURIComponent(profile.email)}`}>
                Change password
              </Link>
            </section>
            <section>
              <div>
                <strong>This browser</strong>
                <p>End your current Emazy session on this device.</p>
              </div>
              <Link to={routes.logout}>Sign out</Link>
            </section>
          </div>
          <EmailChangeDialog open={emailOpen} onClose={() => setEmailOpen(false)} />
        </div>
      )}
    </AccountPageState>
  );
}
